// extracted by mini-css-extract-plugin
module.exports = {"VenueSupply":"_2kDVxpTz6MHjRMMBjrsqPJ","VenueSupply__top-section":"_2dOL_L29s15DCHCozzn-ZW","VenueSupply__title":"_3JuqA--EwbS-6SgA5J_cB0"};